export { BnplForm } from './BnplForm.web';
export type { BnplFormProps } from './types';
